import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledLibraryTopbar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 5px;

  h1 {
    color: ${Colors.textDark};

    .subtitle {
      margin-left: 10px;
      font-size: 20px;
      font-weight: normal;
      color: ${Colors.text};
      line-height: var(--line-height-h1);
    }

    .anticon {
      margin-left: 5px;
      font-size: 20px;
      font-weight: normal;
      color: ${Colors.text};
      line-height: var(--line-height-h1);
    }
  }

  .theme-info {
    flex: 1;
    position: relative;

    .avatar {
      position: absolute;
      line-height: 0 !important;
      top: calc(50% - 22px);
    }

    .theme-title {
      margin-left: 50px;
      color: ${Colors.purple};
    }
  }

  @media (max-width: ${MediaQueryBreakpoints.md}) {
    margin-top: 10px;
    flex-direction: column;
    gap: 20px;
    position: relative;
    h1:not(.theme-title) {
      display: none;
    }
    .back-button {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
`;
